<template>
  <div class="DicCascader">
    <el-cascader v-model="value" :options="options" :props="optionProps" clearable></el-cascader>
  </div>
</template>

<script>
import { codeType } from '@/api/common.js'
export default {
  props: {
    typeCode: {
      // 查询的字典值
      type: String,
      default: ''
    },
    selectValue: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      options: [],
      value: [],
      optionProps: {
        label: 'codeName',
        children: 'childNode',
        value: 'codeName',
        checkStrictly: true,
        expandTrigger: 'hover',
        multiple: true
      }
    }
  },
  watch: {
    value: function (newVal) {
      console.log(newVal, ':::new')

      this.$emit('update:selectValue', newVal)
    },
    selectValue: function (newVal) {
      this.value = newVal
      this.$emit('update:selectValue', newVal)
    }
  },
  created() {
    this.getCode()
  },
  methods: {
    //根据code查询标签
    async getCode() {
      this.options = sessionStorage.getItem(this.typeCode)
      if (!this.options) {
        const res = await codeType({ code: this.typeCode })
        sessionStorage.setItem(this.typeCode, JSON.stringify(res.data.data))
      }
      this.options = JSON.parse(sessionStorage.getItem(this.typeCode))
    }
  }
}
</script>

<style scoped lang="less">
.buttonContent {
  display: flex;
}
</style>
